import React, { useContext } from 'react'
import { userContext } from 'global/context/sub-contexts/userContext'

const UserImage = () => {
  const info = useContext(userContext).getProfile()

  const chooseURL = () => {
    let userImageUrl = '/images/Avatars/default-user.png'
    if (info.profilePhotoId) {
      userImageUrl = `"https://s3.amazonaws.com/dbugc_prod/${info.profilePhotoId}` //These legacy images were stored in a different user attribute and on an S3 bucket.
    } else if (info.profileImageUrl) {
      //The new image urls are our current avatars.
      userImageUrl = info.profileImageUrl
    }
    return userImageUrl
  }
  return <img src={chooseURL()} alt="My Profile" />
}
export default UserImage
